import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__http_route } from '@shared/network/ENUM__http_route';
import { EPageSlug } from './EPageTypeOptionalParam';

export const ENUM__page_type = {
  //SYSTEM
  ANY: '*',

  MAIN: '/',
  PAGE_404: '/404',
  PAGE_403: '/403',

  IMAGE_TO_COLOR_MAP: '/image_to_color_map',

  STRIPE_CHECKOUT_RESULT: `${ENUM__http_route.STRIPE_CHECKOUT_RESULT}/${EPageSlug.PAYMENT_STATUS}`,

  ADMIN: '/admin',

  AUTH: '/auth',
  AUTH_WITH_MAGIC_LINK: `${CONSTANTS__shared.ROUTE_MAGIC_LINK}/${EPageSlug.TOKEN_MAGIC_LINK}`,
  AUTH_VERIFY_EMAIL_AND_LOGIN: `${CONSTANTS__shared.ROUTE_VERIFICATE_EMAIL_AND_LOGIN}/${EPageSlug.TOKEN_EMAIL_VERIFICATION}`,

  AUTH_REGISTER: '/auth/register',

  COLLECTIONS_WITHOUT_PARAMS: '/collections',
  COLLECTIONS: `/collections/${EPageSlug.ID_COLLECTION_OPTIONAL}`,

  USER_TASK_WITHOUT_PARAMS: '/user_task',
  USER_TASK: `/user_task/${EPageSlug.ID_USER_TASK_OPTIONAL}`,

  GENERATION_WITHOUT_PARAMS: '/generation',
  GENERATION: `/generation/${EPageSlug.ID_GENERATION_OPTIONAL}`,

  OPEN_POSE_WITHOUT_PARAMS: '/open_pose',

  DIFFUSION_MODELS_WITHOUT_PARAMS: '/diffusion_models',
  DIFFUSION_MODELS: `/diffusion_models/${EPageSlug.ID_WORKSPACE_OPTIONAL}`,

  RESERVATIONS_WITHOUT_PARAMS: '/admin/reservations_free',

  SETTINGS_USER_WITHOUT_PARAMS: CONSTANTS__shared.ROUTE_SETTINGS_USER,
  SETTINGS_USER: `${CONSTANTS__shared.ROUTE_SETTINGS_USER}/${EPageSlug.ID_WORKSPACE_OPTIONAL}`,

  SETTINGS_WORKSPACE_WITHOUT_PARAMS: '/settings/workspace',
  SETTINGS_WORKSPACE: `/settings/workspace/${EPageSlug.ID_WORKSPACE_OPTIONAL}`,

  SEARCH_WITHOUT_PARAMS: '/search',
  SEARCH: `/search/${EPageSlug.ID_SEARCH_OPTIONAL}`,

  WORKSPACE_INVITATION: `${CONSTANTS__shared.ROUTE_WORKSPACE_INVITATION}/${EPageSlug.TOKEN_USER_WORKSPACE_INVITATION}`,

  BUILD_PATH_COLLECTIONS: function (collection_id: string) {
    return ENUM__page_type.COLLECTIONS.replace(EPageSlug.ID_COLLECTION_OPTIONAL, collection_id).replace(/\/+$/, '');
  },

  BUILD_PATH_DIFFUSION_MODELS: function (workspace_id: string = '') {
    return ENUM__page_type.DIFFUSION_MODELS.replace(EPageSlug.ID_WORKSPACE_OPTIONAL, workspace_id).replace(/\/+$/, '');
  },

  BUILD_PATH_GENERATION: function (generation_id: string = '') {
    return ENUM__page_type.GENERATION.replace(EPageSlug.ID_GENERATION_OPTIONAL, generation_id).replace(/\/+$/, '');
  },

  BUILD_PATH_USER_TASK: function (user_task: string = '') {
    return ENUM__page_type.USER_TASK.replace(EPageSlug.ID_USER_TASK_OPTIONAL, user_task).replace(/\/+$/, '');
  },

  BUILD_PATH_SEARCH: function (search_id: string = '') {
    return ENUM__page_type.SEARCH.replace(EPageSlug.ID_SEARCH_OPTIONAL, search_id).replace(/\/+$/, '');
  },

  BUILD_PATH_SETTINGS_USER: function (workspace_id: string = '') {
    return ENUM__page_type.SETTINGS_USER.replace(EPageSlug.ID_WORKSPACE_OPTIONAL, workspace_id).replace(/\/+$/, '');
  },

  BUILD_PATH_SETTINGS_WORKSPACE: function (workspace_id: string = '') {
    return ENUM__page_type.SETTINGS_WORKSPACE.replace(EPageSlug.ID_WORKSPACE_OPTIONAL, workspace_id).replace(/\/+$/, '');
  },

  BUILD_FULL_PATH_WORKSPACE_INVITATION: function (token: string) {
    return `${window.location.origin}${ENUM__page_type.WORKSPACE_INVITATION.replace(EPageSlug.TOKEN_USER_WORKSPACE_INVITATION, token)}`;
  },
};
